const translations = {
    esc: 'ESC'
};

export default translations;
